/* Special-experience microsite callout — sits above the standard prospect list. */
export function GiggleCallout() {
  return (
    <section className="mb-10" data-testid="admin-special-experiences">
      <div className="flex items-center gap-2 mb-3">
        <span className="mono text-[10px] uppercase tracking-[0.22em] font-bold px-2.5 py-1 rounded-full"
              style={{ background: "#FF801D", color: "#fff" }}>
          Custom microsite
        </span>
        <h2 className="serif font-light text-2xl tracking-tight">Special experiences (not the standard deck)</h2>
      </div>
      <article
        className="rounded-xl p-5 md:p-6 grid grid-cols-1 md:grid-cols-[auto_1fr_auto] gap-5 items-center"
        style={{ background: "linear-gradient(135deg, #1A2B5E 0%, #0F1B40 100%)", color: "#fff" }}
        data-testid="admin-giggle-card"
      >
        <div className="h-14 w-14 rounded-lg bg-white/95 p-2 flex items-center justify-center flex-shrink-0">
          <img src="/brand/prospects/giggle-finance.png" alt="Giggle Finance" className="max-h-full max-w-full object-contain" />
        </div>
        <div className="min-w-0">
          <div className="mono text-[10px] uppercase tracking-[0.22em] font-bold" style={{ color: "#40CFDE" }}>
            RFP response · prepared for Pia Thompson · General Counsel
          </div>
          <div className="serif text-2xl mt-1 leading-tight">Giggle Finance · MCA Compliance Training Proposal</div>
          <p className="text-[13px] mt-2 leading-relaxed" style={{ color: "rgba(255,255,255,0.78)" }}>
            Dedicated single-page microsite in Giggle's brand · 50-course catalog · custom track builder ·
            seat-calculator with multi-year prepay · member-rate add-ons · interactive training samples ·
            print-to-PDF. <strong style={{ color: "#fff" }}>Not the standard CompliSun deck.</strong>
          </p>
        </div>
        <div className="flex flex-col gap-2 md:min-w-[260px]">
          <div className="flex items-center gap-2">
            <span className="mono text-[9px] uppercase tracking-[0.22em] min-w-[48px]" style={{ color: "#40CFDE" }}>URL</span>
            <a
              href="/p/giggle-finance"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="admin-giggle-url"
              className="flex-1 mono text-[12px] px-2.5 py-1.5 rounded-md break-all"
              style={{
                background: "rgba(255,255,255,0.10)",
                border: "1px solid rgba(64,207,222,0.30)",
                color: "#fff",
                textDecoration: "none",
              }}
            >
              /p/giggle-finance
            </a>
          </div>
          <div className="flex items-center gap-2">
            <span className="mono text-[9px] uppercase tracking-[0.22em] min-w-[48px]" style={{ color: "#40CFDE" }}>Code</span>
            <button
              type="button"
              onClick={(e) => { navigator.clipboard.writeText("CompliSun2026"); const el = e.currentTarget; const orig = el.style.background; el.style.background = "rgba(16,185,129,0.35)"; setTimeout(() => { el.style.background = orig; }, 600); }}
              data-testid="admin-giggle-code"
              className="flex-1 mono text-[12px] px-2.5 py-1.5 rounded-md text-left tracking-[0.1em]"
              style={{
                background: "rgba(255,255,255,0.10)",
                border: "1px solid rgba(64,207,222,0.30)",
                color: "#fff",
              }}
              title="Click to copy"
            >
              CompliSun2026
            </button>
          </div>
          <a
            href="/p/giggle-finance"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="admin-giggle-open"
            className="mono text-[11px] uppercase tracking-[0.18em] font-bold inline-flex items-center justify-center gap-1.5 h-10 px-4 rounded-md mt-1 transition-colors"
            style={{ background: "#FF801D", color: "#fff" }}
          >
            Open the microsite →
          </a>
        </div>
      </article>
    </section>
  );
}
